import type {
  MultiStepFormStep,
  MultiStepFormStepSection,
} from '#/components/Form/MultiStepForm/MultiStepFormTypes';

export function normalizeStepsForSinglePage(
  steps: MultiStepFormStep[],
  singlePage?: boolean,
): MultiStepFormStep[] {
  if (!singlePage) {
    return steps;
  }

  return steps.reduce(
    (acc, { title, preTitle, disabled, beforeSection, glowUp, sections }) => {
      const [step] = acc;

      if (title && !(sections.length && sections[0].title)) {
        const [firstSection, ...restSections] = sections;
        const updatedFirstSection = {
          ...firstSection,
          title,
          preTitle,
          disabled,
          beforeSection,
          glowUp,
        };

        return [
          {
            sections: step.sections.concat([
              updatedFirstSection,
              ...restSections,
            ]),
          },
        ];
      }

      return [
        {
          sections: step.sections.concat(sections),
        },
      ];
    },
    [
      {
        sections: [] as MultiStepFormStepSection[],
      },
    ],
  );
}
